import { render, staticRenderFns } from "./AuthTel.vue?vue&type=template&id=7edb8788"
import script from "./AuthTel.vue?vue&type=script&lang=js"
export * from "./AuthTel.vue?vue&type=script&lang=js"
import style0 from "./AuthTel.vue?vue&type=style&index=0&id=7edb8788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports